import type { Offer, Product } from "@decocms/apps-commerce/types";

const IN_STOCK = "https://schema.org/InStock";

function offersOf(offers: Product["offers"]): Offer[] {
  return offers?.offers ?? [];
}

/**
 * Produto com pelo menos um SKU vendável. Olha a oferta do próprio produto e
 * a de cada variante (`isVariantOf.hasVariant`), porque os loaders preenchem
 * um ou outro conforme a origem (busca legada x Intelligent Search).
 */
export function isProductAvailable(product: Product): boolean {
  if (offersOf(product.offers).some((offer) => offer.availability === IN_STOCK)) return true;
  return (product.isVariantOf?.hasVariant ?? []).some((variant) =>
    offersOf(variant.offers).some((offer) => offer.availability === IN_STOCK)
  );
}

/**
 * Tira das vitrines/prateleiras o produto sem nenhum SKU em estoque.
 *
 * Produtos com "Exibir no site sem estoque" (`ShowWithoutStock`) marcado no
 * catálogo da VTEX continuam com PDP no ar (200 + "Avise-me quando chegar",
 * em vez de 404), mas não devem aparecer em prateleira, categoria ou busca.
 */
export function onlyAvailableProducts<T>(result: T): T {
  if (!Array.isArray(result)) return result;
  return result.filter((product) => isProductAvailable(product as Product)) as T;
}
